@if (iconName) {
  <rt-icon [name]="iconName" [colorToken]="iconColor()" [size]="size().iconSize" />
}
